import { createSlice } from '@reduxjs/toolkit'
import { TradeProposal } from '../sdk/model'

const initialState : Record<string, TradeProposal[]> = {};

const tradeDataLoadSlice = createSlice({
  name: 'tradeDataLoad',
  initialState,
  reducers: {
    setTradeDataLoad (state, action) {
      return state = action.payload
    }
  }
})

export const { setTradeDataLoad } = tradeDataLoadSlice.actions
export default tradeDataLoadSlice.reducer